import React, { useState, useEffect } from "react";
import BreadCrumb from "../../BreadCrumb";
import Layout from "../../Layout";
import { useDispatch, useSelector } from "react-redux";
import PageLoader from "../../../common/Loader";
import { Card } from "react-bootstrap";
import * as Icon from "react-feather";
import "./index.css";
import { useHistory, useParams } from "react-router";
import { paymentStatusAction ,downloadInvoice} from "../../../redux/actions/paymentAction";
import { ONLINE } from "../../constants";
import { Link } from "react-router-dom";

const PaymentStatus = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  const history = useHistory();
  const OrderId = params.id;
  const { loader ,paymentDetails } = useSelector((state) => state.payment);
  const [currentPageLoader, setCurrentPageLoader] = useState(false);

  const downloadPaymentReceipt = ()=>{
    dispatch(downloadInvoice({OrderId}))
  }

  const [sideMenu, setSideMenu] = useState(true);
  useEffect(() => {
      if(OrderId){
        dispatch(paymentStatusAction({OrderId}))
      }else{
        history.push('/dashboard')
      }
  }, [])
  const onSideMenu = (value) => {
    setSideMenu(value);
  };


  return (
    <div className="page-wrapper">
      <Layout onClick={onSideMenu} />
      <PageLoader loader={loader || currentPageLoader}>
        <div
          className={`main-content d-flex flex-column ${
            sideMenu ? "" : "hide-sidemenu"
          }`}
        >
          <div className="main-content-header">
            <BreadCrumb />
          </div>
          <div className="spacer"></div>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"></div>
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                {Object.keys(paymentDetails).length > 0 ? (
                <Card>
                {
                    (paymentDetails.PaymentStatus.status === 'Payment Completed' || ( paymentDetails.PaymentStatus.status === "Payment Pending" && paymentDetails.ChequeTransaction ) ) ? (
                        <>
                        <Card.Header className="payment-status-success text-center">
                  <div style={{ fontSize: "50px" }}>
                    <i className="lni-check-mark-circle" />
                  </div>
                  <h1>Payment Successful </h1>
                  <h5> We have received your payment.</h5>
                  <h5> Details of the transaction are included below</h5>
                </Card.Header>
                <Card.Body>
                  <dl class="row">

                  <dt class="col-xs-12 col-sm-12 col-md-8 col-lg-1 col-xl-1"></dt>
                    <dt class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-truncate">
                      Date
                    </dt>
                    <dd class="col-xs-12 col-sm-12 col-md-6 col-lg-8 col-xl-8">
                      {paymentDetails.payment_date}
                    </dd>
                    <dt class="col-xs-12 col-sm-12 col-md-8 col-lg-1 col-xl-1"></dt>
                    <dt class="col-xs-12 col-sm-12 col-md-2 col-lg-3 col-xl-3">Order Id</dt>
                    <dd class="col-xs-12 col-sm-12 col-md-6 col-lg-8 col-xl-8">{paymentDetails.ORDER_ID}
                    </dd>
                    {paymentDetails.PaymentMode.name === ONLINE ? (
                            <>
                            <dt class="col-xs-12 col-sm-12 col-md-8 col-lg-1 col-xl-1"></dt>
                            <dt class="col-xs-12 col-sm-12 col-md-8 col-lg-3 col-xl-3">Transaction Id</dt>
                            <dd class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                                {paymentDetails.transactionId}
                            </dd>
                            </>
                    ) : null }
                    
                    <dt class="col-xs-12 col-sm-12 col-md-8 col-lg-1 col-xl-1"></dt>
                    <dt class="col-xs-12 col-sm-12 col-md-2 col-lg-3 col-xl-3">Pay Mode</dt>
                    <dd class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                        {paymentDetails.PaymentMode.name}
                    </dd>
                    <dt class="col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1"></dt>
                    <dt class="col-xs-6 col-sm-4 col-md-2 col-lg-3 col-xl-3">Amount</dt>
                    <dd class="col-xs-6 col-sm-4 col-md-8 col-lg-8 col-xl-8">
                    &#x20b9; {paymentDetails.amount}
                    </dd>
                  </dl>
                  <div className="text-center">
                      Clck here to redirect <Link to="/dashboard">Dashboard</Link>.
                      {
                        ( paymentDetails.PaymentStatus.status === "Payment Pending" && paymentDetails.ChequeTransaction ) ? null : (
                          <>
                          and  <span className="btn  app-default-button btn-primary btn-sm">
                           <span className="fa fa-download" onClick={downloadPaymentReceipt}></span>
                          </span> the receiept
                          </>
                        )
                      }
                       
                  </div>
                </Card.Body>
                        </>
                    ) : (
                        <>
                        <Card.Header className="payment-status-failure text-center">
                  <div style={{ fontSize: "50px" }}>
                  <i className="fa fa-times-circle" />
                  </div>
                  <h1>Payment Failed </h1>
                  
                </Card.Header>
                <Card.Body>
                  <dl class="row">

                    <dt class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2"></dt>
                    <dt class="col-xs-12 col-sm-12 col-md-2 col-lg-3 col-xl-3 text-truncate">
                      Date
                    </dt>
                    <dd class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      {paymentDetails.payment_date}
                    </dd>
                    <dt class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2"></dt>
                    <dt class="col-xs-12 col-sm-12 col-md-2 col-lg-3 col-xl-3">Order Id</dt>
                    <dd class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">{paymentDetails.ORDER_ID}
                    </dd>
                  </dl>
                  <div className="text-center">
                      Clck here to redirect <Link to="/dashboard">Dashboard</Link>.
                  </div>
                </Card.Body>
                        </>
                    )
                }
              </Card>
                ) : null }
              
            </div>
          </div>
        </div>
      </PageLoader>
    </div>
  );
};

export default PaymentStatus;
